/* src/app/main/pages/home-page/component/home-apps/home-apps.component.css */
.our-apps-row .card {
  background-color: #FAFAFA;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  border-top: 4px solid transparent;
  cursor: pointer;
}
.our-apps-row .card:hover {
  border-top: 4px solid #E8882D;
}
.our-apps-row .card .card-body {
  padding-bottom: 0;
  padding-left: 10px;
  padding-right: 10px;
}
.our-apps-row .card .card-body .card-text {
  margin-bottom: 30px;
  min-height: 63px;
}
.our-apps-row .card .btn-details {
  background-color: transparent;
  text-decoration: underline;
  border: none;
  color: #E8882D;
  padding: 8px 30px;
  border-radius: 0px;
}
.our-apps-row .card .btn-details:hover {
  background-color: #E8882D;
  color: #fff;
}
.our-apps-row .card:hover .btn-details {
  background-color: #E8882D;
  color: #fff;
}
.our-apps-row .card .btn-details:focus {
  border: none;
  box-shadow: none;
}
.our-apps-row .app-img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 1px;
}
.our-apps-row .card h5 {
  font-size: 17px;
}
@media (min-width: 992px) {
  .our-apps-row .col-lg-3 {
    flex: 0 0 28%;
    max-width: 28%;
  }
  .our-apps-row .offset-lg-1 {
    margin-left: 5.333333%;
  }
}
@media (min-device-width: 1920px) {
  .our-apps-row .card .card-body {
    padding-left: 15px;
    padding-right: 15px;
  }
  .our-apps-row .card .card-body .card-text {
    font-size: 20px !important;
    min-height: 90px !important;
  }
  .our-apps-row .card h5 {
    font-size: 24px !important;
  }
}
@media (min-device-width: 1600px) {
  .our-apps-row .card .card-body .card-text {
    min-height: 75px;
    font-size: 17px;
  }
  .our-apps-row .card h5 {
    font-size: 22px;
    margin-bottom: 20px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .our-apps-row .card h5 {
    font-size: 19px;
  }
  .our-apps-row .card .card-body .card-text {
    font-size: 15px;
  }
  .our-apps-row .card .btn-details {
    font-size: 16px;
  }
}
@media (min-device-width: 1200px) and (max-device-width: 1280px) {
  .our-apps-row .card .card-body .card-text {
    min-height: 84px;
  }
}
@media (device-width: 1200px) {
  .our-apps-row .card h5 {
    font-size: 17px;
  }
}
@media (min-device-width: 768px) and (max-device-width: 1024px) {
  .our-apps-row .card h5 {
    min-height: 42px;
  }
  .our-apps-row .card .card-body .card-text {
    min-height: 84px;
  }
}
@media (max-width: 767px) {
  .our-apps-row .card {
    margin-bottom: 30px;
  }
}
/*# sourceMappingURL=home-apps.component.css.map */
